module.exports = __webpack_public_path__ + "img/6a.6d9b8240.svg";